import type { DepositStatusUnionType } from '@api';

type GetDepositStatusColorReturnType = {
  backgroundColor: string;
  textColor: string;
};

export const getDepositStatusColor = (
  status: DepositStatusUnionType
): GetDepositStatusColorReturnType => {
  switch (status) {
    case 'PENDING':
      return { backgroundColor: '#FFEBC2', textColor: '#453007' };
    case 'APPROVED':
      return { backgroundColor: '#C7F5D9', textColor: '#0C4121' };
    case 'PAID':
      return { backgroundColor: '#C5E4FA', textColor: '#0A3553' };
  }
};
